export enum PrizeType {
  CASH = 'CASH',
  VOUCHER = 'VOUCHER',
  REWARD_SELECTION = 'REWARD_SELECTION',
  DONATION = 'DONATION',
}
